import React, { useContext } from 'react';

import AuthContext from '../contexts/auth';
import AuthenticatedRoutes from './AuthenticatedRoutes';
import SignRoutes from './SignRoutes';

const Routes: React.FC = () => {
  const { signed } = useContext(AuthContext);
  return signed ? <AuthenticatedRoutes /> : <SignRoutes />;
};

export default Routes;
